<template>
    <div>
        <text-form-group
                :value="value.view_reference"
                name="view_reference"
                label="View ID"
                :error="(errors.view_reference || [])[0]"
                @input="input('view_reference', $event)"
        />

        <select-form-group
                :value="value.metric"
                name="metric"
                label="Metric"
                :error="(errors.metric || [])[0]"
                @input="input('metric', $event)"
                :options="[{value: 'ga:sessions', label: 'Sessions'}, {value: 'ga:pageViews', label: 'Page Views'}]"
        />
    </div>
</template>

<script>
    import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {SelectFormGroup, TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        methods: {
            input(key, value) {
                this.$emit('input', {...this.value, [key]: value})
            }
        }
    }
</script>
